
import DialogNotice from './dialog-notice.vue';

export default {
  name: 'month-board',
  components: {
    DialogNotice: DialogNotice
  },
  props: {
    value: { type: Boolean, default: false },
    title: { type: String, default: '○○○邸' },
    pubType: { type: String, default: 'market_report' },
    kind: { type: String, default: 'publication' },
    live: { type: Boolean, default: true },
    focusYear: { type: Number, default: 0 },
    focusMonth: { type: Number, default: 0 }
  },
  data: function () {
    var d = new Date();
    var y = d.getFullYear();
    return {
      year: y,
      month: d.getMonth() + 1,
      nowYear: y,
      fileMap: {},
      picked: {},
      listLoaded: false,
      downloading: false,
      noticeVisible: false
    };
  },
  computed: {
    opened: function () {
      return this.value;
    },
    hintText: function () {
      if (this.live && this.listLoaded && !Object.keys(this.fileMap).length) {
        return 'まだ公開されていません';
      }
      return 'ダウンロードを行う月を選択してください';
    },
    yearOptions: function () {
      var now = this.nowYear;
      var set = {};
      var y;
      var keys;
      var i;
      var yr;
      var fy;
      for (y = now - 3; y <= now + 1; y++) {
        set[y] = true;
      }
      keys = Object.keys(this.fileMap);
      for (i = 0; i < keys.length; i++) {
        yr = parseInt(String(keys[i]).split('-')[0], 10);
        if (isFinite(yr)) set[yr] = true;
      }
      fy = Number(this.focusYear);
      if (isFinite(fy) && fy > 0) set[fy] = true;
      return Object.keys(set).map(function (k) {
        return parseInt(k, 10);
      }).sort(function (a, b) {
        return a - b;
      });
    }
  },
  watch: {
    opened: function (v) {
      if (v) this.onOpen();
    }
  },
  methods: {
    toast: function (msg) {
      if (window.A && A.toast) A.toast(msg);
    },
    canShiftYear: function (delta) {
      var options = this.yearOptions;
      var index = options.indexOf(Number(this.year));
      return index > -1 && index + Number(delta) >= 0 && index + Number(delta) < options.length;
    },
    shiftYear: function (delta) {
      var options = this.yearOptions;
      var index = options.indexOf(Number(this.year));
      var next = index + Number(delta);
      if (index < 0 || next < 0 || next >= options.length) return;
      this.year = options[next];
    },
    monthKey: function (year, month) {
      return String(year) + '-' + String(month);
    },
    hasFile: function (m) {
      return !!this.fileMap[this.monthKey(this.year, m)];
    },
    isPicked: function (m) {
      return !!this.picked[this.monthKey(this.year, m)];
    },
    pickMonth: function (m) {
      if (this.downloading) return;
      if (this.live && !this.hasFile(m)) return;
      var key = this.monthKey(this.year, m);
      var next = Object.assign({}, this.picked);
      if (next[key]) delete next[key];
      else next[key] = true;
      this.picked = next;
    },
    focusValid: function () {
      var y = Number(this.focusYear);
      var m = Number(this.focusMonth);
      return isFinite(y) && y > 0 && isFinite(m) && m >= 1 && m <= 12;
    },
    applyFocusOrLatest: function (bestY, bestM) {
      var picked = {};
      var key;
      if (this.focusValid()) {
        key = this.monthKey(this.focusYear, this.focusMonth);
        if (!this.live || this.fileMap[key]) {
          this.year = Number(this.focusYear);
          picked[key] = true;
        } else if (bestY > 0) {
          this.year = bestY;
          picked[this.monthKey(bestY, bestM)] = true;
        } else {
          this.year = Number(this.focusYear);
        }
        this.picked = picked;
        return;
      }
      if (bestY > 0) {
        this.year = bestY;
        picked[this.monthKey(bestY, bestM)] = true;
      }
      this.picked = picked;
    },
    onOpen: function () {
      var d = new Date();
      this.fileMap = {};
      this.picked = {};
      this.listLoaded = !this.live;
      this.downloading = false;
      if (!this.live) {
        if (this.focusValid()) {
          this.year = Number(this.focusYear);
          this.month = Number(this.focusMonth);
        } else {
          this.year = d.getFullYear();
          this.month = d.getMonth() + 1;
        }
        var seed = {};
        seed[this.monthKey(this.year, this.month)] = true;
        this.picked = seed;
        return;
      }
      if (this.focusValid()) {
        this.year = Number(this.focusYear);
        this.month = Number(this.focusMonth);
      }
      this.loadList();
    },
    loadList: function () {
      if (this.kind === 'settlement') {
        this.loadPublished();
        return;
      }
      var t = this;
      if (!this.pubType) {
        this.listLoaded = true;
        return;
      }
      axios.get('landlord/publications', { params: { type: this.pubType } }).then(function (res) {
        var items = [];
        if (res.data && res.data.status == 1 && res.data.options && res.data.options.items) {
          items = res.data.options.items;
        }
        t.applyItems(items, true);
      }).catch(function () {
        t.listLoaded = true;
        t.toast('読み込みに失敗しました');
      });
    },
    loadPublished: function () {
      var t = this;
      axios.get('landlord/settlement/publishedMonths').then(function (res) {
        var items = [];
        if (res.data && res.data.status == 1 && res.data.options && res.data.options.items) {
          items = res.data.options.items;
        }
        t.applyItems(items, false);
      }).catch(function () {
        t.listLoaded = true;
        t.toast('読み込みに失敗しました');
      });
    },
    applyItems: function (items, requireId) {
      var map = {};
      var bestY = 0;
      var bestM = 1;
      var i;
      var it;
      var y;
      var m;
      var key;
      items = items || [];
      for (i = 0; i < items.length; i++) {
        it = items[i];
        y = parseInt(it.year, 10);
        m = parseInt(it.month, 10);
        if (!isFinite(y) || !isFinite(m)) continue;
        if (requireId && !it.id) continue;
        key = this.monthKey(y, m);
        if (!map[key]) map[key] = requireId ? it.id : 1;
        if (y > bestY || (y === bestY && m >= bestM)) {
          bestY = y;
          bestM = m;
        }
      }
      this.fileMap = map;
      this.listLoaded = true;
      this.applyFocusOrLatest(bestY, bestM);
    },
    selectedList: function () {
      var keys = Object.keys(this.picked || {});
      var out = [];
      var i;
      var parts;
      var y;
      var m;
      for (i = 0; i < keys.length; i++) {
        if (!this.picked[keys[i]]) continue;
        parts = String(keys[i]).split('-');
        y = parseInt(parts[0], 10);
        m = parseInt(parts[1], 10);
        if (!isFinite(y) || !isFinite(m) || m < 1 || m > 12) continue;
        if (this.live && !this.fileMap[keys[i]]) continue;
        out.push({
          year: y,
          month: m,
          id: this.fileMap[keys[i]] || 0
        });
      }
      out.sort(function (a, b) {
        if (a.year !== b.year) return a.year - b.year;
        return a.month - b.month;
      });
      return out;
    },
    downloadName: function (res, fallback) {
      var cd = '';
      if (res.headers) {
        cd = res.headers['content-disposition'] || res.headers['Content-Disposition'] || '';
      }
      var matched = /filename\*=UTF-8''([^;]+)|filename="?([^";]+)"?/i.exec(cd);
      if (matched) {
        var raw = matched[1] || matched[2];
        try {
          return decodeURIComponent(raw);
        } catch (e) {
          return raw;
        }
      }
      return fallback;
    },
    saveBlob: function (blob, filename) {
      var url = window.URL.createObjectURL(blob);
      var a = document.createElement('a');
      a.href = url;
      a.download = filename;
      a.style.display = 'none';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      setTimeout(function () {
        window.URL.revokeObjectURL(url);
      }, 1000);
    },
    readError: function (blob, done) {
      var reader = new FileReader();
      reader.onload = function () {
        var json = {};
        try {
          json = JSON.parse(reader.result);
        } catch (e) {}
        done(json || {});
      };
      reader.readAsText(blob);
    },
    downloadBlob: function (url, params, fallback) {
      var t = this;
      if (this.downloading) return;
      this.downloading = true;
      axios.get(url, { params: params || {}, responseType: 'blob' }).then(function (res) {
        var blob = res.data;
        var ctype = '';
        if (res.headers) {
          ctype = res.headers['content-type'] || res.headers['Content-Type'] || '';
        }
        if (!ctype && blob && blob.type) ctype = blob.type;
        if (ctype.indexOf('application/json') !== -1 || ctype.indexOf('text/') === 0) {
          t.readError(blob, function (json) {
            var msg = json && json.msg;
            if (!msg && json && (json.status === 'empty' || json.status === 0)) {
              msg = 'まだ公開されていません';
            }
            t.toast(msg || 'ダウンロードに失敗しました');
            t.downloading = false;
          });
          return;
        }
        t.saveBlob(blob, t.downloadName(res, fallback));
        t.downloading = false;
        t.close();
        t.noticeVisible = true;
      }).catch(function () {
        t.downloading = false;
        t.toast('ダウンロードに失敗しました');
      });
    },
    close: function () {
      this.$emit('input', false);
    },
    onOk: function () {
      var pairs;
      var ids;
      var items;
      var one;
      var fallback;
      if (this.live && !this.listLoaded) return;
      pairs = this.selectedList();
      if (!pairs.length) {
        this.toast('月を選択してください');
        return;
      }
      if (pairs.length > 36) {
        this.toast('一度に選択できるのは36ヶ月までです');
        return;
      }
      if (!this.live) {
        this.close();
        this.noticeVisible = true;
        return;
      }
      if (this.kind === 'settlement') {
        if (pairs.length === 1) {
          one = pairs[0];
          this.downloadBlob('landlord/settlement/file', {
            year: one.year,
            month: one.month
          }, one.year + '-' + one.month + '.pdf');
          return;
        }
        items = pairs.map(function (pair) {
          return pair.year + '-' + pair.month;
        }).join(',');
        this.downloadBlob('landlord/settlement/zip', { items: items }, 'settlement.zip');
        return;
      }
      if (pairs.length === 1) {
        one = pairs[0];
        if (!one.id) return;
        fallback = (this.pubType || 'publication') + '-' + one.year + '-' + one.month + '.pdf';
        this.downloadBlob('landlord/publications/file/' + one.id, {}, fallback);
        return;
      }
      ids = pairs.map(function (pair) {
        return pair.id;
      }).filter(function (id) {
        return id;
      });
      if (ids.length !== pairs.length) return;
      fallback = (this.pubType === 'kyoran_news' ? 'kyoran-news' : 'market-report') + '.zip';
      this.downloadBlob('landlord/publications/zip', {
        type: this.pubType,
        ids: ids.join(',')
      }, fallback);
    },
    onCancel: function () {
      this.close();
    }
  }
};
